import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import { mapTabSlider } from './map-swiper';
import { isMobile } from './vars';
import isEn from '../utils/isEn';

if (document.querySelector('.map')) {
  /* global pinImagesObj, places, transport, mapCenter, centerImgPath */

  mapboxgl.accessToken =
  'pk.eyJ1Ijoibm90YW1lZGlhIiwiYSI6ImNsMzJzMXU5aTAwOXczYm4xZThpcWJsMm8ifQ.EZddW8-M3XG6NaY3uuXL3g';

  const mapInputList = document.querySelectorAll('.js-map-tab input');
  const nav = new mapboxgl.NavigationControl({
  showCompass: false,
  });

  const layerIDs = [];
  let mapZoom;
  let iconPinSize;
  const URLarr = [];

  if ($(window).width() > 1024) {
  mapZoom = 15;
  iconPinSize = 0.5;
  } else {
  mapZoom = 13.5;
  iconPinSize = 0.3;
  }

  const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/notamedia/cl32s63rg000m14qjy4voqinl',
  center: mapCenter,
  zoom: mapZoom,
  maxZoom: 17,
  minZoom: 13,
  });

  const setLayoutPropertyFunction = (layer, visibilityProp) => {
  map.setLayoutProperty(layer, 'visibility', visibilityProp);
  };

  map.on('load', () => {
  map.loadImage(centerImgPath, (error, image) => {
    if (error) throw error;

    map.addImage('stadium_map', image);

    map.addSource('point', {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [37.62639, 55.78111],
            },
          },
        ],
      },
    });

    map.addLayer({
      id: 'points',
      type: 'symbol',
      source: 'point',
      layout: {
        'icon-image': 'stadium_map',
        'icon-size': [
          'interpolate',
          ['linear'],
          ['zoom'],
          13,
          0.125,
          14,
          0.25,
          15,
          0.5,
          16,
          1,
          17,
          2,
        ],
        'icon-offset': [30, -90],
        'icon-allow-overlap': true,
      },
    });
  });

  map.addSource('places', {
    type: 'geojson',
    data: places,
    generateId: true,
  });

  for (const marker of places.features) {
    const { type, icon, title } = marker.properties;
    const imgUrl = pinImagesObj[icon];

    const el = document.createElement('div');

    el.className = 'map__marker';
    el.style.backgroundImage = `url(${imgUrl})`;
    el.setAttribute('data-type', `${type}`);
    el.setAttribute('data-title', `${title}`);

    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
  }

  if (isEn()) {
    map.setLayoutProperty('road-label', 'text-field', ['get', 'name_en']);
  }

  $('[data-type="metro"]').show();
  });

  $(document).on('click', '.js-map-button', (e) => {
  const $target = $(e.currentTarget);
  const $mapTab = $target.closest('.js-map-tab');
  const $mapTabSibs = $mapTab.siblings();
  const type = $target.find('input').val();

  if ($(window).width() > 767) {
    $mapTab.addClass('is-active').find('.js-map-content').slideDown(700);
    $mapTabSibs.removeClass('is-active').find('.js-map-content').slideUp(500);
  }

  $('.map__marker').hide();
  $(`[data-type="${type}"]`).show();
  });

  mapTabSlider.on('slideChange', (swiper) => {
  $(swiper.slides[swiper.activeIndex]).find('.js-map-button').click();
  });

  $(document).on('click', '.mapboxgl-marker', (e) => {
  const $target = $(e.target);
  if (!$target.hasClass('is-active') && isMobile) {
    $target.addClass('is-active').siblings().removeClass('is-active');
  }
  });

  map.addControl(nav, 'top-left');

  map.boxZoom.disable();
  map.doubleClickZoom.disable();
  map.dragRotate.disable();
  map.keyboard.disable();
  map.scrollZoom.disable();
  map.touchZoomRotate.enable();
}
